<template>
  <div class="selection-item">
    <h3>{{root.name}} {{$t('editor.root.properties')}}</h3>
    <n-input-text
      :label="$t('editor.root.name')"
      :value="root.name"
      @change="handleNameChange" />
    <n-input-number
      :label="$t('editor.root.num-points')"
      :value="root.numPoints"
      @change="handleNumPointsChange" />
    <div class="bbch group">
      <n-input-number
        :label="$t('editor.root.bbch.min')"
        :value="root.BBCH[0]"
        @change="handleMinBBCHChange" />
      <n-input-number
        :label="$t('editor.root.bbch.max')"
        :value="root.BBCH[1]"
        @change="handleMaxBBCHChange" />
    </div>
    <div class="angle group">
      <n-input-number
        :label="$t('editor.root.angle.min')"
        :value="root.angle[0]"
        step="0.01"
        @change="handleMinAngleChange" />
      <n-input-number
        :label="$t('editor.root.angle.max')"
        :value="root.angle[1]"
        step="0.01"
        @change="handleMaxAngleChange" />
    </div>
    <div class="length group">
      <n-input-number
        :label="$t('editor.root.length.min')"
        :value="root.length[0]"
        step="0.01"
        @change="handleMinLengthChange" />
      <n-input-number
        :label="$t('editor.root.length.max')"
        :value="root.length[1]"
        step="0.01"
        @change="handleMaxLengthChange" />
    </div>
    <n-input-number
      :label="$t('editor.root.bend')"
      :value="root.bend"
      step="0.01"
      @change="handleBendChange" />
    <n-input-number
      :label="$t('editor.root.noise')"
      :value="root.noise"
      step="0.01"
      @change="handleNoiseChange" />
    <h3>{{$t('editor.root.danger-zone')}}</h3>
    <button type="button" class="button--remove" @click="handleRemoveClick">
      {{$t('editor.root.remove')}}
    </button>
  </div>
</template>

<style lang="scss" scoped>

h3 {
  margin-top: 3rem;
}

.button--remove {
  background: var(--color--negative);
}

.group {
  display: flex;
}

</style>

<script>
import { mapMutations, mapState, mapActions } from 'vuex'

import InputNumber from '@/components/InputNumber'
import InputText from '@/components/InputText'

export default {
  components: {
    'n-input-number': InputNumber,
    'n-input-text': InputText
  },
  props: {
    index: {
      type: Number
    }
  },
  computed: {
    ...mapState({
      cropData: (state) => state.crop.data
    }),
    root () {
      return this.cropData.roots[this.index]
    }
  },
  methods: {
    ...mapMutations({
      setRootName: 'crop/setRootName',
      setRootPoints: 'crop/setRootPoints',
      setRootLength: 'crop/setRootLength',
      setRootBBCH: 'crop/setRootBBCH',
      setRootSeed: 'crop/setRootSeed',
      setRootAngle: 'crop/setRootAngle',
      setRootBend: 'crop/setRootBend',
      setRootNoise: 'crop/setRootNoise'
    }),
    ...mapActions({
      removeRootAt: 'editor/removeRootAt'
    }),
    handleNameChange (e) {
      this.setRootName({ index: this.index, name: e.target.value })
    },
    handleNumPointsChange (e) {
      this.setRootPoints({ index: this.index, numPoints: e.target.valueAsNumber })
    },
    handleMinLengthChange (e) {
      this.setRootLength({ index: this.index, min: e.target.valueAsNumber })
    },
    handleMaxLengthChange (e) {
      this.setRootLength({ index: this.index, max: e.target.valueAsNumber })
    },
    handleBendChange (e) {
      this.setRootBend({ index: this.index, bend: e.target.valueAsNumber })
    },
    handleNoiseChange (e) {
      this.setRootNoise({ index: this.index, noise: e.target.valueAsNumber })
    },
    handleMinBBCHChange (e) {
      this.setRootBBCH({ index: this.index, min: e.target.valueAsNumber })
    },
    handleMaxBBCHChange (e) {
      this.setRootBBCH({ index: this.index, max: e.target.valueAsNumber })
    },
    handleMinAngleChange (e) {
      this.setRootAngle({ index: this.index, min: e.target.valueAsNumber })
    },
    handleMaxAngleChange (e) {
      this.setRootAngle({ index: this.index, max: e.target.valueAsNumber })
    },
    handleSeedChange (e) {
      this.setRootSeed({ index: this.index, bend: e.target.valueAsNumber })
    },
    handleRemoveClick (e) {
      if (confirm(this.$t('editor.root.remove-warning'))) {
        this.removeRootAt({ index: this.index })
      }
    }
  }
}
</script>
